// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__1ID4E","fullScreen":"style_fullScreen__1dqAi","hidden":"style_hidden__K4SsS"};